import brazilSvgMap from "@svg-maps/brazil";
import germanySvgMap from "@svg-maps/germany";
import usaSvgMap from "@svg-maps/usa";
import mexicoSvgMap from "@svg-maps/mexico";
import spainSvgMap from "@svg-maps/spain";

function unwrapSvgMapModule(mod) {
  return mod?.default ?? mod;
}

/** Build ISO-style code → label from @svg-maps location ids (handles "sp" and "br-sp"). */
function locationsIdToNameRecord(mod) {
  const map = unwrapSvgMapModule(mod);
  if (!map?.locations?.length) return {};
  return map.locations.reduce((acc, loc) => {
    const rawId = String(loc.id);
    const key = rawId.includes("-")
      ? rawId.split("-").pop().toUpperCase()
      : rawId.toUpperCase();
    acc[key] = loc.name;
    return acc;
  }, {});
}


/** Nigerian state codes (ISO 3166-2:NG style) → display name; API/subregion often sends these codes, not @svg-maps ids. */
const nigeriaStatesMap = {
  AB: "Abia",
  AD: "Adamawa",
  AK: "Akwa Ibom",
  AN: "Anambra",
  BA: "Bauchi",
  BY: "Bayelsa",
  BE: "Benue",
  BO: "Borno",
  CR: "Cross River",
  DE: "Delta",
  EB: "Ebonyi",
  ED: "Edo",
  EK: "Ekiti",
  EN: "Enugu",
  GO: "Gombe",
  IM: "Imo",
  JI: "Jigawa",
  KD: "Kaduna",
  KN: "Kano",
  KT: "Katsina",
  KE: "Kebbi",
  KO: "Kogi",
  KW: "Kwara",
  LA: "Lagos",
  NA: "Nassarawa",
  NI: "Niger",
  OG: "Ogun",
  ON: "Ondo",
  OS: "Osun",
  OY: "Oyo",
  PL: "Plateau",
  RI: "Rivers",
  SO: "Sokoto",
  TA: "Taraba",
  YO: "Yobe",
  ZA: "Zamfara",
  FC: "Federal Capital Territory",
};

// Countries States
export const brazilStates = locationsIdToNameRecord(brazilSvgMap);
export const germanyStates = locationsIdToNameRecord(germanySvgMap);
export const usaStates = locationsIdToNameRecord(usaSvgMap);
export const nigeriaStates = nigeriaStatesMap;
export const mexicoStates = locationsIdToNameRecord(mexicoSvgMap);
export const spainRegions = locationsIdToNameRecord(spainSvgMap);

// Legacy export for backwards compatibility
export const states = usaStates;

export function getStateNameByAbbreviation(abbr, country = "USA") {
  const upperAbbr = abbr.toUpperCase();
  
  switch (country.toUpperCase()) {
    case "USA":
      return usaStates[upperAbbr] || null;
    case "NIGERIA":
    case "NGA":
      return nigeriaStates[upperAbbr] || null;
    case "MEXICO":
    case "MEX":
      return mexicoStates[upperAbbr] || null;
    case "SPAIN":
      return spainRegions[upperAbbr] || null;
    case "BRAZIL":
    case "BR":
    case "BRA":
      return brazilStates[upperAbbr] || null;
    case "GERMANY":
    case "DE":
    case "DEU":
      return germanyStates[upperAbbr] || null;
    default:
      return usaStates[upperAbbr] || null;
  }
}

export function getStatesByCountry(country) {
  switch (country.toUpperCase()) {
    case "USA":
      return usaStates;
    case "NIGERIA":
    case "NGA":
      return nigeriaStates;
    case "MEXICO":
    case "MEX":
      return mexicoStates;
    case "SPAIN":
      return spainRegions;
    case "BRAZIL":
    case "BR":
    case "BRA":
      return brazilStates;
    case "GERMANY":
    case "DE":
    case "DEU":
      return germanyStates;
    default:
      return usaStates;
  }
}
